import {formatMoney} from '@shopify/theme-currency';
import {
    DISCOUNT_PERCENTAGES,
    DISCOUNT_THRESHOLDS,
    formatPrice,
    getTotalPrice,
    getVariantIdQueryParams,
    SELECTED_PRODUCTS_KEY, UPDATE_SELECTED_PRODUCTS
} from 'sections/bundle-builder/bundle-builder-helpers';

const HIDDEN_CLASS = 'hidden';
const REMOVE_TEXT = 'Remove';
const DATA_PRODUCT_ID = 'data-product-id';
const ADD_TO_CART_BTN = '.btn--bundle-builder-add-to-cart';
const BACK_BTN = '.btn--bundle-builder-back';
const HEADER_BACK_BTN = '.menu__link--bundle-builder-back';
const DISCOUNT_PROGRESS_BAR = '.discount-progress-bar';
const DATA_FREE_SHIPPING_THRESHOLD = 'data-free-shipping-threshold';

class BundleBuilderReview extends HTMLElement {
    #selectedProducts = {};

    get selectedProducts() {
        return this.#selectedProducts;
    }

    set selectedProducts(value) {
        this.#selectedProducts = value;
        this.updateBundleSummary();
    }

    get hasFreeShipping() {
        return this.total >= this.querySelector(DISCOUNT_PROGRESS_BAR).getAttribute(DATA_FREE_SHIPPING_THRESHOLD);
    }

    get currentDiscount() {
        return this.getDiscountAmount();
    }

    get total() {
        return getTotalPrice();
    }

    constructor() {
        super();
    }

    connectedCallback() {
        const variantIds = getVariantIdQueryParams();
        if (variantIds.length) {
            document.querySelector(BACK_BTN).style.display = 'none';
            document.querySelector(`${HEADER_BACK_BTN} > .icon__arrow--cart-back`).style.display = 'none';
        }

        const sessionSelectedProducts = sessionStorage.getItem(SELECTED_PRODUCTS_KEY);
        if(sessionSelectedProducts) {
            this.selectedProducts = JSON.parse(sessionSelectedProducts);
        }

        const addToCartBtn = this.querySelector(ADD_TO_CART_BTN);

        if(window.shoplift) {
            window.shoplift.isHypothesisActive('b745f56c-1cd7-461d-8869-44f1e342d05b')
                .then((isActive) => {
                    if (isActive && addToCartBtn) {
                        addToCartBtn.innerText = 'Checkout';
                    }
                }).catch((error) => {
                    console.error('Error checking Hypothesis status:', error);
                });
        }


        addToCartBtn.addEventListener('click', async () => {
            addToCartBtn.textContent = window.translations.addingToCart;
            addToCartBtn.disabled = true;
            const headers = {
                'Content-Type': 'application/json'
            };
            const res = await fetch('/cart.js', {
                cache: 'no-cache',
                headers
            });
            const cart = await res.json();
            const itemsToRemove = {};
            cart.items.forEach(item => {
                if(item.properties['_bundle'] === true) {
                    itemsToRemove[item.id] = 0;
                }
            });

            if (Object.keys(itemsToRemove).length > 0) {
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers,
                    body: JSON.stringify({ updates: itemsToRemove })
                });
            }

            const items = Object.keys(this.selectedProducts).map((productId) => {
                return {
                    id: this.selectedProducts[productId].variantId,
                    quantity: 1,
                    properties: { '_bundle': true }
                };
            });
            fetch(window.localeUrl+'/cart/add.js', {
                method: 'POST',
                headers,
                body: JSON.stringify({ items})
            }).then((response) => {
                if(response.status !== 200) {
                    throw response;
                } else {
                    return response.json();
                }
            }).then(async () => {
                let newLocation = window.localeUrl + '/cart';
                if (window.shoplift) {
                    const isHypothesisActive = await window.shoplift.isHypothesisActive('b745f56c-1cd7-461d-8869-44f1e342d05b');
                    if (isHypothesisActive) {
                        newLocation = window.localeUrl + '/checkout';
                    }
                }
                window.location.href = newLocation;
            }).catch((error) => {
                console.error('Error:', error);
                addToCartBtn.textContent = window.translations.addToCart;
                addToCartBtn.disabled = false;
            });
        });

        const headerBackButton = document.querySelector(HEADER_BACK_BTN);
        const backFn = () => history.back();
        headerBackButton.addEventListener('click', backFn);
        this.querySelector(BACK_BTN).addEventListener('click', backFn);

        window.addEventListener(UPDATE_SELECTED_PRODUCTS, (e) => {
            const selectedProducts = e.detail;
            if(selectedProducts) {
                this.selectedProducts = JSON.parse(selectedProducts);
            }
        });
    }

    updateBundleSummary() {
        const summary = this.querySelector('.bundle-builder-item-summary');
        summary.innerHTML = '';
        const selectedProductIds = Object.keys(this.selectedProducts);
        selectedProductIds.forEach((id) => {
            const summaryItem = document.createElement('div');
            summaryItem.classList.add('summary-item');
            const itemImage = document.createElement('img');
            itemImage.alt = this.selectedProducts[id].name;
            itemImage.src = this.selectedProducts[id].image;
            summaryItem.appendChild(itemImage);

            const summaryItemMetadata = document.createElement('div');
            summaryItemMetadata.classList.add('summary-item-metadata');

            const summaryItemMetadataLeft = document.createElement('div');
            summaryItemMetadataLeft.classList.add('summary-item-metadata-left');

            const itemName = document.createElement('span');
            itemName.classList.add('summary-item-name');
            itemName.innerHTML = this.selectedProducts[id].name;
            summaryItemMetadataLeft.appendChild(itemName);

            const itemRemoveButton = document.createElement('bundle-builder-remove-button');
            itemRemoveButton.classList.add('remove-button--summary');
            itemRemoveButton.textContent = REMOVE_TEXT;
            itemRemoveButton.setAttribute(DATA_PRODUCT_ID, id);
            summaryItemMetadataLeft.appendChild(itemRemoveButton);

            summaryItemMetadata.appendChild(summaryItemMetadataLeft);

            const summaryItemMetadataRight = document.createElement('div');
            summaryItemMetadataRight.classList.add('summary-item-metadata-right');

            if(this.currentDiscount > 0) {
                const itemOriginalPrice = document.createElement('s');
                itemOriginalPrice.classList.add('summary-item-price');
                itemOriginalPrice.innerHTML = formatPrice(this.selectedProducts[id].price);
                summaryItemMetadataRight.appendChild(itemOriginalPrice);

                const itemSalePrice = document.createElement('span');
                itemSalePrice.classList.add('summary-item-price', 'summary-item-price--sale');
                const salePrice = parseInt(this.selectedProducts[id].price) * (1 - this.currentDiscount / 100);
                itemSalePrice.innerHTML = formatPrice(salePrice.toString());
                summaryItemMetadataRight.appendChild(itemSalePrice);
            } else {
                const itemPrice = document.createElement('span');
                itemPrice.classList.add('summary-item-price');
                itemPrice.innerHTML = formatPrice(this.selectedProducts[id].price);
                summaryItemMetadataRight.appendChild(itemPrice);
            }

            summaryItemMetadata.appendChild(summaryItemMetadataRight);

            summaryItem.appendChild(summaryItemMetadata);
            summary.appendChild(summaryItem);
        });

        const priceSummary = this.querySelector('.bundle-builder-price-summary');
        const totalWithDiscount = this.total * (1 - this.currentDiscount / 100);
        const totalWithDiscountAndShipping = totalWithDiscount + (this.hasFreeShipping ? 0 : 500);
        const displayedDiscount = this.total - totalWithDiscount;
        if (displayedDiscount > 0) {
            priceSummary.querySelectorAll('.price-summary-item--discount').forEach((el) => {
                el.classList.remove(HIDDEN_CLASS);
                if (el.id === 'bundle-builder-discount') {
                    el.innerHTML = `${formatMoney(displayedDiscount, '${{amount}}')}`;
                }
            });
        } else {
            priceSummary.querySelectorAll('.price-summary-item--discount').forEach((el) => {
                el.classList.add(HIDDEN_CLASS);
            });
        }
        priceSummary.querySelector('#bundle-builder-shipping').innerHTML = this.hasFreeShipping ? window.translations.free : '$5.00';
        priceSummary.querySelector('#bundle-builder-total').innerHTML = formatMoney(totalWithDiscountAndShipping, '${{amount}}');

        this.querySelector(ADD_TO_CART_BTN).disabled = selectedProductIds.length <= 0;
    }

    getDiscountAmount() {
        let currentDiscount = 0;
        if (this.total >= DISCOUNT_THRESHOLDS[0] && this.total < DISCOUNT_THRESHOLDS[1]) {
            currentDiscount = DISCOUNT_PERCENTAGES[0];
        } else if (this.total >= DISCOUNT_THRESHOLDS[1] && this.total < DISCOUNT_THRESHOLDS[2]) {
            currentDiscount = DISCOUNT_PERCENTAGES[1];
        } else if (this.total >= DISCOUNT_THRESHOLDS[2]) {
            currentDiscount = DISCOUNT_PERCENTAGES[2];
        }

        return currentDiscount;
    }
}

customElements.define('bundle-builder-review', BundleBuilderReview);
